import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const shopCategories = [
    { label: "衣物", path: "/shop?category=衣物" },
    { label: "生活用品", path: "/shop?category=生活用品" },
    { label: "寵物用品", path: "/shop?category=寵物用品" },
    { label: "母嬰用品", path: "/shop?category=母嬰用品" },
    { label: "電子產品", path: "/shop?category=電子產品" },
    { label: "食品", path: "/shop?category=食品" },
    { label: "其他", path: "/shop?category=其他" },
  ];

  return (
    <footer className="bg-stone-900 text-stone-300">
      {/* Main Footer Content */}
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col md:flex-row items-start justify-between gap-12 md:gap-10">

            {/* Left: Brand Info */}
            <div className="w-full md:max-w-[340px] shrink-0">
              <Link to="/" className="inline-flex items-center gap-3">
                <div className="h-9 w-9 rounded-lg bg-rose-700 flex items-center justify-center shrink-0">
                  <i className="ri-skull-line text-white text-lg" />
                </div>
                <span className="font-display text-[22px] font-bold text-white tracking-tight">
                  Star Skull shop
                </span>
              </Link>
              <p className="font-body text-sm text-[#A0A0A0] mt-5 leading-[1.6]">
                買賣和發現時尚、家居裝飾、美妝等商品。加入數百萬時尚愛好者的社交交易平台。
              </p>
            </div>

            {/* Center: Shop Categories */}
            <div className="shrink-0">
              <h4 className="font-body text-sm font-bold text-white uppercase tracking-wider mb-5">
                商品分類
              </h4>
              <ul className="flex flex-col">
                {shopCategories.map((item) => (
                  <li key={item.label} className="mb-3 last:mb-0">
                    <Link
                      to={item.path}
                      className="font-body text-sm text-[#A0A0A0] hover:text-white transition-colors duration-200"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Customer Service Info */}
            <div className="shrink-0">
              <h4 className="font-body text-sm font-bold text-white uppercase tracking-wider mb-5">
                客服資訊
              </h4>
              <ul className="flex flex-col">
                <li className="mb-3">
                  <a
                    href="https://line.me/ti/p/hm5V5_QNCq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 font-body text-sm text-[#A0A0A0] hover:text-white transition-colors duration-200"
                  >
                    <i className="ri-chat-3-line text-[#06C755] text-base" />
                    聯絡客服
                  </a>
                </li>
                <li className="mb-3 last:mb-0">
                  <button
                    onClick={() => {
                      if (isHome) {
                        document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });
                      } else {
                        navigate("/?scrollTo=how-it-works");
                      }
                    }}
                    className="flex items-center gap-2 font-body text-sm text-[#A0A0A0] hover:text-white transition-colors duration-200 text-left cursor-pointer"
                  >
                    <i className="ri-flow-chart text-stone-500 text-base" />
                    認購批發運作流程
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-stone-500">
            &copy; 2015 Star Skull shop, Inc. 版權所有。
          </p>
        </div>
      </div>
    </footer>
  );
}